module.exports = __webpack_public_path__ + "img/logo-header.2fb1c069.png";